import React, { useState } from "react";
import { motion } from "framer-motion";
import { resume } from "../Constant/common";

const MotionDivPart = ({ heading, content, darkMode ,detailAbout}) => {
 const [isViewMore,SetIsViewMore] = useState(false)
  const handleViewMore=()=>{
    SetIsViewMore(!isViewMore)
  }
  return (
    <motion.div
      key={heading}
      initial="hidden"
      whileInView={"visible"}
      variants={{
        visible: {
          y: 0,
          opacity: 1,
          transition: {
            type: "spring",
          },
        },
        hidden: { opacity: 1, y: 80 },
      }}
    >
      <h4 className="mt-12 text-3xl font-semibold text-blue-500">{heading}</h4>
      <p
        className={
          darkMode
            ? "mt-4 text-xl text-justify text-gray-500"
            : "mt-4 text-xl text-justify text-white"
        }
      >
        {content} {" "} 
        {/* view more btn in Technologies and Tools */}
        {!resume && <>
          {(!isViewMore && heading==="A bit about me") &&<strong onClick={handleViewMore}>view more...</strong>}
          {isViewMore && detailAbout}  {" "}  
          {/* view less btn */}
          {isViewMore &&<strong onClick={handleViewMore}>view less.</strong>}  
        </>}
      </p>

    </motion.div>
  );
};

export default MotionDivPart;
